<mat-card appearance="outlined" class='syn--flat syn-searchbar' [style.padding-bottom]="'0.4em'">
    <mat-card-content [style.padding-bottom]="'0em'">

        <div class='syn-searchbar__container'>
            <div *ngIf="title" class="title">{{ title }}</div>
            <div class='syn-searchbar__query'>
                <form class="searchbar" (submit)="submitSearch($event)" (reset)="clearQuery()">
                    <mat-form-field floatLabel="never" class="searchbar" appearance="outline">
                        <mat-label>{{ translations.ACTIONS.SEARCH }}</mat-label>
                        <input autofocus #query matInput [placeholder]="translations.ACTIONS.SEARCH"
                               [(ngModel)]="searchQuery" name="searchQuery"
                               (keyup)='onQueryChange($event.target.value)' />
                        <div class="search-icons">
                            <button mat-icon-button type="reset" [disabled]="hasFilters && hasSearchQuery">
                                <mat-icon svgIcon="close"></mat-icon>
                            </button>
                            <button mat-icon-button type="submit" [disabled]="hasFilters && hasSearchQuery">
                                <mat-icon svgIcon="magnify"></mat-icon>
                            </button>
                        </div>
                    </mat-form-field>
                </form>

                <button [disabled]="storageFilters.length <= 0" mat-button [matMenuTriggerFor]="filtersMenu">
                    {{ translations.ACTIONS.MY_FILTERS }}
                </button>

                <button *ngIf="defaultFilters.length > 0" mat-button [matMenuTriggerFor]="defaultFiltersMenu">
                    {{ translations.ACTIONS.DEFAULT_FILTERS }}
                </button>

                <button [disabled]="hasFilters && hasSearchQuery" mat-button (click)='openFilterSaveDialog()'>
                    {{ translations.ACTIONS.SAVE_FILTER }}
                </button>

                <button mat-icon-button aria-label="copy search link" [disabled]="hasFilters && hasSearchQuery"
                        (click)="copyLink()" [matTooltip]="translations.TOOLTIPS.COPY_LINK">
                    <mat-icon svgIcon="link-variant"></mat-icon>
                </button>

                <mat-menu #advancedSearchMenu="matMenu" [overlapTrigger]="false">
                    <button [disabled]="hasFilters" mat-menu-item (click)='removeAll()'>
                        <mat-icon svgIcon="cancel"></mat-icon>{{ translations.ACTIONS.DELETE_ALL }}
                    </button>
                </mat-menu>

                <mat-menu #filtersMenu="matMenu">

                    <div mat-menu-item *ngFor="let storageFilter of storageFilters" class='syn-searchbar__filters'>

                        <div fxLayout="row" fxLayoutAlign="space-between none" class='row'>
                            <button mat-button (click)="loadSelectedFilter(storageFilter)"
                                    class='syn-searchbar__filters__filter-button max-width_filter-button' [matTooltip]="storageFilter.name">
                                <span class='syn-searchbar__filters__filter-button__label'>
                                    {{storageFilter.name}}
                                </span>
                            </button>
                            <button mat-icon-button aria-label="set favorite"
                                    (click)='handleUpdateFavorite(storageFilter, $event)'
                                    [matTooltip]="translations.TOOLTIPS.UPDATE_FAVORITE_FILTER">
                                <mat-icon [svgIcon]="storageFilter.isFavorite ? 'star' : 'star-outline'"></mat-icon>
                            </button>
                            <button mat-icon-button aria-label="delete filter"
                                    (click)="deleteSelectedFilter(storageFilter, $event)"
                                    [matTooltip]="translations.TOOLTIPS.DELETE_FILTER">
                                <mat-icon class="icon-delete-forever" svgIcon="delete-outline">
                                </mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-menu>
                <mat-menu #defaultFiltersMenu="matMenu">

                    <button mat-menu-item *ngFor="let defaultFilter of defaultFilters"
                            (click)="loadSelectedFilter(defaultFilter)" class='syn-searchbar__filters__filter-button'>
                        <div fxLayout="row" fxLayoutAlign="space-between none" class='row'>
                            <span class='syn-searchbar__filters__filter-button__label'>
                                {{defaultFilter.name}}
                            </span>
                        </div>
                    </button>
                </mat-menu>

            </div>

            <div class='syn-searchbar__filters'>

                <div class='syn-searchbar__filters__chips'>
                    <mat-chip-listbox>
                        <mat-chip disableRipple color="primary" [removable]="true" *ngFor='let filter of state.filters'
                                  (removed)='removeFilter(filter)'>
                            {{ filter.chipLabel || filter.query }}
                            <mat-icon matChipRemove svgIcon="close-circle"></mat-icon>
                        </mat-chip>

                        <mat-menu #addFilterMenu="matMenu" [overlapTrigger]="false">
                            <syn-search-v2-filter-widget [trigger]='trigger' [facets]='facets'
                                                         [translations]='translations' (submitted)='addFilter($event)'>
                            </syn-search-v2-filter-widget>
                        </mat-menu>

                        <button mat-button [matMenuTriggerFor]="addFilterMenu" #addFilterMenuTrigger>
                            + {{ this.translations.ACTIONS.ADD_FILTER}}
                        </button>

                        <button mat-button [disabled]="(state?.filters || []).length === 0" (click)="removeAll()">
                            <mat-icon class="icon-delete-forever" svgIcon="delete-outline"></mat-icon>
                            {{ translations.ACTIONS.DELETE_FILTERS }}
                        </button>

                    </mat-chip-listbox>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
